export default function buildAdminFormsQuery(searchParams) {
  const params = new URLSearchParams(
    typeof searchParams === "string" ? searchParams : searchParams?.toString?.() || ""
  );
  const q = new URLSearchParams();

  const slug = params.get("slug")?.trim();
  if (slug) q.set("slug", slug);

  const inUse = params.get("in_use");
  if (inUse && ["all", "1", "0"].includes(inUse) && inUse !== "all") {
    q.set("in_use", inUse);
  }

  return q.toString();
}
